import React, { Component } from "react";
import { TableRow, Box, Text, TableCell } from "grommet";

export class LogbookTableRows extends Component {
  state = {
    loaded: false,
    logbookInstances: []
  };

  componentDidMount = () => {
    this.getImageUrls(this.props.logbook);
  };

  getPrettyDateString = dateString => {
    const firstArray = dateString.split("T");
    const timeString = firstArray[1];
    const secondArray = timeString.split("+");
    return secondArray[0];
  };

  getImageUrls = async logbook => {
    const firebase = this.props.firebase;
    let logbookInstances = logbook.LogbookInstances;
    let i = 0;
    for (const logbookInstance of logbookInstances) {
      let newLogbookInstance = logbookInstance;
      let j = 0;
      for (const logbookItemInstance of logbookInstance.LogBookItemInstances) {
        let newLogbookItemInstance;
        if (logbookItemInstance.LogbookItem.inputFieldType === "photo") {
          console.log("logbookiteminstancedid = ", logbookItemInstance.id);
          const images = firebase
            .storage()
            .ref()
            .child("photos/");
          const image = images.child(
            "thumb_" + logbookItemInstance.id + ".jpg"
          );
          const url = await image
            .getDownloadURL()
            .then(async url => {
              console.log(url);
              return url;
            })
            .catch(async err => {
              console.log(err);
              return "not found";
            });
          newLogbookItemInstance = {
            ...logbookItemInstance,
            url: url
          };
          newLogbookInstance.LogBookItemInstances[j] = newLogbookItemInstance;
        }
        j++;
      }

      logbookInstances[i] = newLogbookInstance;
      i++;
    }
    console.log("logbookInstances = ", logbookInstances);
    const newState = {
      ...this.state,
      loaded: true,
      logbookInstances: logbookInstances
    };

    this.setState(newState);
  };

  render() {
    const logbookInstances = this.state.logbookInstances;
    if (this.state.loaded) {
      return logbookInstances.map(logbookInstance => {
        const startTime = this.getPrettyDateString(logbookInstance.startTime);
        let endTimeBlock;
        if (logbookInstance.timeType === "Sign-in/Sign-out") {
          const endTime = this.getPrettyDateString(logbookInstance.endTime);
          endTimeBlock = (
            <TableCell>
              <Text>{endTime}</Text>
            </TableCell>
          );
        }
        return (
          <TableRow>
            <TableCell>
              <Text>{logbookInstance.Building_Gaurd.Gaurd.GaurdFirstName}</Text>
            </TableCell>
            {logbookInstance.LogBookItemInstances.map(logbookItemInstance => {
              let cellContents;
              if (logbookItemInstance.type === "text") {
                cellContents = <Text>{logbookItemInstance.description}</Text>;
              } else if (logbookItemInstance.type === "photo") {
                cellContents = (
                  <img
                    height="200px"
                    width="200px"
                    object-fit="cover"
                    src={logbookItemInstance.url}
                  />
                );
              }
              return <TableCell>{cellContents}</TableCell>;
            })}
            <TableCell>
              <Text>{startTime}</Text>
            </TableCell>
            {endTimeBlock}
          </TableRow>
        );
      });
    } else {
      return <div>Loading...</div>;
    }
  }
}

export default LogbookTableRows;
